import styles from './styles.module.scss'

export default function JsonCode({code,copiar}) {
    return(
        <div className={styles.jsonCode}>
            <button style={{width: '5vw', backgroundColor: 'red'}} onClick={copiar}>Copiar</button>
            <h3>Código Json</h3>
        <div className={styles.frame}>
               <pre> {code}</pre>

            </div>
        </div>
    )
}